const E = 5;
export {
  E as NUMBER_OF_FILTER_PER_LINE
};
//# sourceMappingURL=BoxWrapper.constants.js.map
